import React from 'react';

class RedirectPage extends React.Component {
  render() {
    return <div>Redirect to somewhere</div>;
  }
}

export default RedirectPage;
